<mat-form-field>
  <input
    matInput
    placeholder="Zoek Artikel"
    aria-label="article"
    [matAutocomplete]="auto"
    [formControl]="searchCtrl"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selectedArticle()"
      [displayWith]="getArticleName"
      >
      @for (article of results$ | async; track article) {
        <mat-option [value]="article">
          {{ article.title }} ({{
          article.publishDate | amDateFormat: "YYYY/MM/DD"
          }})
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
